<template>
    <invite-client-buttons :session="session" :team-language="session.team_language" />
</template>

<script>
import InviteClientButtons from '../InviteClientButtons.vue';

export default {
    components: { InviteClientButtons },
    props: {
        session: {
            type: Object,
            required: true
        },
    },
}
</script>
